import jimboComponents from './components';
import jimboPalette from './palette';
import jimboTypography from './typography';

const jimboTheme = {
  components: jimboComponents,
  palette: jimboPalette,
  typography: jimboTypography,
};

export default jimboTheme;
